import { ConfigProvider } from 'antd';

import antConfig from '@/ant-config';
import RouterView from '@/react_app/common/RouterView';
import Header from '@/react_app/components/BillingUsage/Global/Header/Header';
import {
	OverviewContext,
	SettingsContext,
	UsageHistoryContext,
	PaymentMethodContext,
	InvoiceHistoryContext,
} from '@/react_app/components/BillingUsage/contexts';
import { BillingUsageLayoutDataProviderProps } from '@/react_app/components/BillingUsage/types';

const Layout = ({
	overviewContextValue,
	settingsContextValue,
	usageHistoryContextValue,
	paymentMethodsContextValue,
	invoiceHistoryContextValue,
}: BillingUsageLayoutDataProviderProps) => (
	<UsageHistoryContext.Provider value={usageHistoryContextValue}>
		<InvoiceHistoryContext.Provider value={invoiceHistoryContextValue}>
			<PaymentMethodContext.Provider value={paymentMethodsContextValue}>
				<SettingsContext.Provider value={settingsContextValue}>
					<OverviewContext.Provider value={overviewContextValue}>
						<ConfigProvider theme={antConfig}>
							<div className="h-screen max-h-screen overflow-x-hidden overflow-y-auto">
								<Header title="Billing & usage" />
								<div className="py-10 px-7">
									<RouterView />
								</div>
							</div>
						</ConfigProvider>
					</OverviewContext.Provider>
				</SettingsContext.Provider>
			</PaymentMethodContext.Provider>
		</InvoiceHistoryContext.Provider>
	</UsageHistoryContext.Provider>
);

export default Layout;
